import type { FC } from "react";
import { CloseOutlined } from "@ant-design/icons";

interface AnnouncementPopupProps {
  title: string;
  content: string;
  logo: string;
  icon: string;
  buttonText: string;
  onClose?: () => void;
  onButtonClick?: () => void;
}

const AnnouncementPopup: FC<AnnouncementPopupProps> = ({
  title,
  content,
  logo,
  icon,
  buttonText,
  onClose,
  onButtonClick,
}) => (
  <div className="email-status-popup">
    <div className="popup-card">
      {onClose ? (
        <button className="close-btn" onClick={onClose} aria-label="Close">
          <CloseOutlined />
        </button>
      ) : null}

      <div className="logo-row">
        <img src={icon} alt="Popup Icon" className="popup-icon" />
        <img src={logo} alt="Announcement Logo" className="popup-logo" />
      </div>

      <div className="popup-divider" />
      <h2 className="popup-title">{title}</h2>

      <div className="announcement-content">
        <p>{content}</p>
      </div>

      <button className="popup-btn" onClick={onButtonClick}>
        {buttonText}
      </button>
    </div>
  </div>
);

export default AnnouncementPopup;
